<script setup lang="ts">
import { ref } from "vue";
import { Permission } from "../../../../../types/auth";
import { CashierDuty, PosStation, RecordStatus } from "../../../../../types/models";
import { FilterField, TableAction, TableField } from "../../../../../components/table/table";
import ListTemplate from "../../../../../components/ui/common/ListTemplate.vue";
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue'
import { api } from "../../../../../api/Api";

defineProps<{
  posStation?: PosStation | undefined
  cashierDuty?: CashierDuty | null
}>();

const emit = defineEmits<{
  (e: 'quotation', data: any): void
  (e: 'close'): void
}>()

const endPoint = "revenue/sales/pos/";
const title = "Sales Quotations";
const selectedData = ref<any | null>(null);
const showForm = ref(false);
const formMode = ref<
  "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
>("view");
const refreshData = ref(false);
const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'document_no', caption: 'Ref. No', sortable: true, fieldType: 'text'},
  { name: 'warehouse', caption: 'Warehouse', sortable: true, fieldType: 'text' },
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text' },
  { name: 'customer', caption: 'customer', sortable: true, fieldType: 'text' },
  { name: 'net_total', caption: 'Amount', sortable: true, fieldType: 'number' },
  { name: 'sales_channel', caption: 'Channel', sortable: true, fieldType: 'text' },
  { name: 'delivery_date', caption: 'Delivery By', sortable: true, fieldType: 'date' },
  { name: 'credit_term', caption: 'Payment Terms', sortable: true, fieldType: 'text' },
  { name: 'sales_person', caption: 'Sales Rep', sortable: true, fieldType: 'text' },
  { name: 'customer_reference', caption: 'customer Reference', sortable: true, fieldType: 'text'},
  { name: 'to_deliver', caption: 'To Deliver', sortable: false, fieldType: 'boolean' },
  { name: 'record_status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const actions: TableAction[] = [
  {
    name: "convert-to-invoice",
    icon: "Receipt",
    variant: "green",
    title: "Create Invoice",
    permission: "create",
    visible: (item) => item.record_status == 'Approved' && !item.invoice,
  },
];

const handleGetQuotation = async (item: any) => {
  const response = await api.post(
    (endPoint.slice(-1) == "/" ? endPoint : endPoint + "/") +
      "get-quotation",
    {
      id: item.uid,
    }
  );
  if (response.success == true) {
    console.log('emit =?> quotation')
    emit('quotation', response.data)
  }
};

const filterFields: FilterField[] = [
  {
    name: "active",
    label: "Status",
    type: "select",
    value: "",
    options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
];

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  console.log('changeMode', mode)
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data: any) => {
  selectedData.value = data;
};

const record_status = ref<RecordStatus[]>([]);

const handleLists = (list: any) => {
  record_status.value = list["record_status"];
};

const handleTableActions = (action: any, data: any)  => {
  selectedData.value = data
  if (action == 'convert-to-invoice') {
    handleGetQuotation(data)
  }
}

const handlePermissions = (perm: Permission[]) => {
  permissions.value = perm;
};

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
/*const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}*/

</script>

<template>
    <ModalFormTemplate
    mode="view" title="Sales Quotations" :endPoint="endPoint" :fullscreen="true"
    :tabList="[]" 
    @close="$emit('close')"
    >
    <template #form>
  <ListTemplate
   ref="listViewRef"
    endPoint="/clients/revenue/sales/sales-quotations/"
    :ignore-max-height="true"
    :title="title"
    :fields="fields"
    :actions="actions"
    :show-header="false"
    :filterFields="filterFields"
    @permissions="handlePermissions"
    :tabList="[]"
    :refreshData="refreshData"
    @custom="handleTableActions"
    @mode="changeMode"
    @show="showForm = true"
    :showForm="showForm"
    @lists="handleLists"
    :allow-disable="false"
    :show-quick-view="true"
    :show-share-actions="true"
    :allow-edit="false"
    @data="handleData"
  >
  </ListTemplate>
  </template>
  </ModalFormTemplate>


</template>
